import React from 'react';
import { Field } from 'redux-form';
import { renderNumberPercentage } from '../../Utils/renderField/renderField';
import { positivePercentageField } from '../../../../utility/getErrors';
import './IvaCredit.css';

const CreditoFiscal = props => {
    const { change, parameterTaxCredit } = props;


    const handlePercentageChange = (e, fieldName, relatedFieldName) => {
        const value = parseFloat(e) || 0;
        let remainingPercentage = 100 - value;
        change(fieldName, value);
        change(relatedFieldName, remainingPercentage);
    };

    const handleIvaRetentionDistributionChange = (e, relatedField) => {
        const value = parseFloat(e) || 0;
        const relatedFieldValue = parseFloat(parameterTaxCredit[relatedField]) || 0;
        const total = value + relatedFieldValue;

        const total_no_retenido = 100 - total
        change(e, value);
        change('parameter_tax_credit.iva_subject_to_withholding', total);
        change('parameter_tax_credit.iva_not_withheld', total_no_retenido)

    };

    return (
        <div>
            <h2 className='titulo_parrafos'>Crédito fiscal</h2>
            <div className='fn-info'>
                <div className="iva-credit__fields-row">
                    {/* Sección izquierda */}
                    <div className="iva-credit__fields-column">
                        <span>Distribución de compras por FE y FN</span>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="nombre" className="m-0">Porcentaje de factura normal</label>
                            <Field
                                name="parameter_tax_credit.normal_invoice"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                                onChange={(e) => handlePercentageChange(e, 'parameter_tax_credit.normal_invoice', 'parameter_tax_credit.special_invoice')}
                            />
                        </div>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="credito1" className="m-0">Porcentaje de factura especial</label>
                            <Field
                                disabled
                                name="parameter_tax_credit.special_invoice"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="iva-credit__fields-column">
                        <span>Retenciones de factura normal</span>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="nombre" className="m-0">Porcentaje FN genera retención</label>
                            <Field
                                name="parameter_tax_credit.if_it_generates_retention"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                                onChange={(e) => handlePercentageChange(e, 'parameter_tax_credit.if_it_generates_retention', 'parameter_tax_credit.does_not_generate_retencion')}
                            />
                        </div>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="nombre" className="m-0">Porcentaje FN No genera retención</label>
                            <Field
                                disabled
                                name="parameter_tax_credit.does_not_generate_retencion"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className='fn-info'>
                <div className="iva-credit__fields-row">
                    <div className="iva-credit__fields-column">
                        <span>Distribución de IVA sujeto a retención</span>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="nombre" className="m-0">Porcentaje exportado decreto 29-89</label>
                            <Field
                                name="parameter_tax_credit.exported_decree_29_89"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                                onChange={(e) => handleIvaRetentionDistributionChange(e, 'special_taxpayers')}
                            />
                        </div>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="nombre" className="m-0">Porcentaje contribuyentes especiales</label>
                            <Field
                                name="parameter_tax_credit.special_taxpayers"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                                onChange={(e) => handleIvaRetentionDistributionChange(e, 'exported_decree_29_89')}
                            />
                        </div>
                    </div>
                    <div className="iva-credit__fields-column">
                        <span>Retención de IVA</span>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="nombre" className="m-0">Porcentaje de IVA sujeto a retención</label>
                            <Field
                                disabled
                                name="parameter_tax_credit.iva_subject_to_withholding"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="credito1" className="m-0">Porcentaje de IVA no retenido</label>
                            <Field
                                disabled
                                name="parameter_tax_credit.iva_not_withheld"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className='fn-info'>
                <div className="iva-credit__fields-row">
                    <div className="iva-credit__fields-column">
                        <span>Distribución de operaciónes</span>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="nombre" className="m-0">Porcentaje retención Op. Exportación</label>
                            <Field
                                name="parameter_tax_credit.export_op_retention"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                                onChange={(e) => handlePercentageChange(e, 'parameter_tax_credit.export_op_retention', 'parameter_tax_credit.local_op_retention')}
                            />
                        </div>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="nombre" className="m-0">Porcentaje retención Op. Locales</label>
                            <Field
                                disabled
                                name="parameter_tax_credit.local_op_retention"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="iva-credit__fields-column">
                        <span>Distribución por régimen</span>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="nombre" className="m-0">Porcentaje de regímen general</label>
                            <Field
                                name="parameter_tax_credit.normal_regime"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                                onChange={(e) => handlePercentageChange(e, 'parameter_tax_credit.normal_regime','parameter_tax_credit.special_regime')}
                                validate={[positivePercentageField]}
                            />
                        </div>
                        <div className="parametros__field-wrapper">
                            <label htmlFor="nombre" className="m-0">Porcentaje de regímen especial</label>
                            <Field
                                disabled
                                name="parameter_tax_credit.special_regime"
                                component={renderNumberPercentage}
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreditoFiscal;
